import classNames from "classnames";
import { useState } from "react";
import type { TStoreData } from "../../services/api/instances/vectorStoreApi/types";
import { DatabaseHeader } from "./Components/DatabaseHeader";
import { FileContainer } from "./Components/FileContainer";
import { useDatabase } from "./hooks/use-database";
import { useAppModals } from "../../app/state/modalSlice/hook/use-app-modals";
import { TEntityInfo } from "../../common/types/utility";
import { DeleteEntityModal } from "../../common/Components/Modals/components/DeleteEntityModal";
import styles from "./styles.module.css";

export const Database = () => {
  const { storeName, selectedStore, handleNameChange, deleteStore } =
    useDatabase();
  const { handleOpenModal, handleCloseModal } = useAppModals();
  const [info, setInfo] = useState<TEntityInfo | null>(null);

  return (
    <div className={classNames(styles.container)}>
      <DatabaseHeader
        storeName={storeName}
        storeData={selectedStore as TStoreData}
        onDeleteDialog={(info) => {
          handleOpenModal("delete_modal", info, "delete_entity");
          setInfo(info);
        }}
        onNameChange={handleNameChange}
      />
      <FileContainer storeData={selectedStore} />
      <DeleteEntityModal
        service={"knowledge_base"}
        handleDeleteEntity={deleteStore}
        closeModal={handleCloseModal}
        subtype={"delete_entity"}
      />
    </div>
  );
};
